export const files = 'ABCDEFGH'.split('')
export const startFEN =
  'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1'
export const defaultHistorySize = 15
export const modeOptions = [
  { text: 'Two Player', value: '2P' },
  { text: 'AI Level 1', value: 'AI_1' },
  { text: 'AI Level 2', value: 'AI_2' },
  { text: 'AI Level 3', value: 'AI_3' }
]
